import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Homepage } from "./views/homepage/Homepage";
import { ChiSono } from "./views/chi-sono/ChiSono";
import { Faq } from "./views/faq/Faq";
import { Videointervista } from "./views/videointervista/Videointervista";
import { Screening } from "./views/screening/Screening";
import { Contatti } from "./views/contatti/Contatti";
import { Letture } from "./views/letture/Letture";
import { Header } from "./components//header/Header";
import { HeaderMobile } from "./components/header-mobile/HeaderMobile";
import { Footer } from "./components/footer/Footer";
import { Servizi } from "./views/servizi/Servizi";
import { DettaglioServizio } from "./views/servizi/dettaglio-servizio/DettaglioServizio";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.js';
import { DettaglioLettura } from "./views/letture/dettaglio-lettura/DettaglioLettura";

export const App = () => {
    function is_touch_enabled() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }


    return (
        <div className="d-flex flex-column test">
            {!is_touch_enabled() ? <Header /> : <HeaderMobile />}
            <div className="h-full flex-grow-1">
                <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/chi-sono" element={<ChiSono />} />
                    <Route path="/servizi" element={<Servizi />} />
                    <Route path="/contatti" element={<Contatti />} />
                    <Route path="/letture" element={<Letture />} />
                    <Route path="/letture/:dettaglio" element={<DettaglioLettura />} />
                    <Route path="/videointervista" element={<Videointervista />} />
                    <Route path="/screening" element={<Screening />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/servizi/:dettaglio" element={<DettaglioServizio />} />
                </Routes>
            </div>
            <Footer />
        </div>
    );
};
